import React, { useCallback, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import SesionContext from '../contexts/SesionContext';
import { signInWithGoogle, auth, logout } from "../lib/firebase";
import google from '../assets/images/google.png'
import axios from "axios";
import { useAuthState } from "react-firebase-hooks/auth";
import { appConfig } from '../config';

const BtnGoogle = () => {
	const navigate = useNavigate();
	const sesionCtx = useContext(SesionContext);
	const [user, loading] = useAuthState(auth);

	const onClickLogin = useCallback(async () => {
		try {
			await signInWithGoogle();
			sesionCtx.cambiarSitioAdmin(true);
			navigate('/seleccion-de-cliente')
		} catch (error) {
			console.log(error)
		}
	}, [navigate, sesionCtx]);

	const verificarUsuario = useCallback(async () => {
		const url = '/usuarios/es-rol-administrador/' + user.email + '/' + user.uid;

		const response = await axios.create({
			baseURL: appConfig.apiEndpont
		}).get(url);

		if (response.data === true) {
			const idTokenResult = await user.getIdTokenResult(true)
			if (idTokenResult?.claims?.admin) {
				sesionCtx.cambiarSitioAdmin(true);
			}
			if (sesionCtx.cliente.id == null) {
				navigate("/seleccion-de-cliente");
			} else {
				navigate("/carga-de-archivo");
			}
		} else {
			//entonces es cliente, obtiene los clientes asignados al usuario
			const urlClientesUsuarios = '/clientes/usuario/' + user.email;
			const res = await axios.create({ baseURL: appConfig.apiEndpont }).get(urlClientesUsuarios);
			const clientes = res.data;
			if (clientes.length > 0) {
				sesionCtx.cambiarCliente(clientes[0].id, clientes[0].identificacion, clientes[0].nombre);
				navigate("/inicio");
			} else {
				logout();
			}
		}
	}, [navigate, sesionCtx, user]);

	useEffect(() => {
		if (user && !loading) {
			verificarUsuario();
		}
	}, [user, loading, verificarUsuario]);

	return (
		<button onClick={onClickLogin} style={{
			cursor: 'pointer', display: 'flex', justifyContent: 'center', alignItems: 'center',
			marginTop: '30px', boxShadow: '0px 3px 6px #00000029', width: '100%', backgroundColor: '#fff',
			borderRadius: '10px', opacity: '1', textAlign: 'center', padding: '20px', border: 'none',
		}}>

			<img src={google} alt='Logo Google' />
			<span style={{ marginLeft: '10px', color: '#151F47', fontSize: '15px', fontWeight: 'bold' }}>Google</span>
		</button>
	);
};

export default BtnGoogle;
